import React from 'react';
import PropTypes from 'prop-types';

import { SingleSlider } from '../../../../Sliders/index';
import IconPremium from '../../../../Icons/IconPremium';
import IconPromo from '../../../../Icons/IconPromo';

class Slider extends React.Component {
  constructor (props) {
    super(props);

    this.item = this.props.item;
    this.user = this.props.user;
    this.dataSource = this.item.getDataSource();
    this.viewDataSource = this.user.getIn(['data', 'permissions', 'viewDataSource']);
  }

  renderServices () {
    return (
      <div className='services-container'>
        <div className='service-icon-wrp'>
          { this.item.isPremium() && <span data-tip data-for='tip-premium' className='icon-premium'><IconPremium /></span> }
          { this.item.isPromo() && <span data-tip data-for='tip-promo' className='icon-promo'><IconPromo /></span> }
          { this.viewDataSource && this.dataSource && this.dataSource.getApplication() && (<div className='source-data'>{this.dataSource.getApplication().get('fullName')}</div>) }
          { this.viewDataSource && this.dataSource && this.dataSource.getFeed() && (<div className='source-data'>xml</div>) }
          { this.viewDataSource && this.dataSource && this.dataSource.getCianSource() && (<div className='source-data'>{this.dataSource.getCianSource().get('fullName')}</div>) }
        </div>
      </div>
    );
  }

  render () {
    return (
      <div className='slider'>
        <SingleSlider
          className='property-grid-slider'
          photos={this.item.getPhotos()}
          photoSize='320x240'
          showPhotoCount
        />
        { this.renderServices() }
      </div>
    );
  }
}

Slider.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
};

export default Slider;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/Items/Slider.jsx